
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 11c-1.66 0-3-1.34-3-3V4H7c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2v-8h-4m-2-3c0 1.1.9 2 2 2h3.59L12 4.41V8M7 3h5l7 7v9c0 1.66-1.34 3-3 3H7c-1.66 0-3-1.34-3-3V6c0-1.66 1.34-3 3-3z"}})])
          )
        }
      }
    